module.exports = __webpack_public_path__ + "img/rich_richcoincoin.c6dfbd0.png";